import * as actionTypes from 'actions';

const userInfos = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null

const initialState = {
  user: userInfos ? {
    ...userInfos,
    lastWithdrawal: userInfos.lastWithdrawal ? new Date(userInfos.lastWithdrawal) : null,
  } : null,
}

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SESSION_LOGIN: {
      return {
        ...state,
        user: action.user,
      }
    }

    case actionTypes.SESSION_LOGOUT: {
      return {
        ...initialState,
        user: null,
      }
    }

    default: {
      return state;
    }
  }
}

export default sessionReducer
